import React from 'react';
export const searchStat = ({q,c}) => (<span>По запросу {q} найдено страниц {c}</span>);